import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { AccessTeamDTO } from '../../../api/access-team-api';
import { UserDTO } from '../../../api/user-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikCellToggle, FormikTextField } from '../../../components/formik';

interface SaveAccessTeamModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedAccessTeam?: AccessTeamDTO;
    users: UserDTO[];
    onHide: () => void;
    onSave: (values: AccessTeamDTO) => void;
    onDelete?: (accessTeam: AccessTeamDTO) => void;
}

export function SaveAccessTeamModal({
    show,
    allowEdit,
    selectedAccessTeam,
    users,
    onHide,
    onSave,
    onDelete,
}: SaveAccessTeamModalProps) {
    const AccessTeamSchema = yup.object().shape({
        title: yup.string().required(' '),
        description: yup.string(),
        isActive: yup.boolean().required(' '),
    });

    const defaultValues: AccessTeamDTO = {
        serial: selectedAccessTeam?.serial,

        title: selectedAccessTeam ? selectedAccessTeam.title : '',
        description: selectedAccessTeam ? selectedAccessTeam.description : '',
        isActive: selectedAccessTeam ? selectedAccessTeam.isActive : true,
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={AccessTeamSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedAccessTeam ? 'edit-access-team' : 'new-access-team'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedAccessTeam && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedAccessTeam)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="title"
                                name="title"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="description"
                                name="description"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikCellToggle
                                label={<T>is-active</T>}
                                name="isActive"
                                readOnly={!allowEdit}
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
